import { Routes } from '@angular/router';

import { adminPlatformChildRoutes } from '@app/routing/admin-platform.routes';
import { publicSiteChildRoutes } from '@app/routing/public-site.routes';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@core/layout/public-shell/public-shell.component').then((m) => m.PublicShellComponent),
    children: [
      ...publicSiteChildRoutes,
      ...adminPlatformChildRoutes,
      {
        path: '**',
        loadComponent: () =>
          import('@features/not-found/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
        data: { publicShellLayout: 'minimal' },
      },
    ],
  },
];
